import houseMain from '../../../images/landing/house-main.jpg'
import houseElm from '../../../images/landing/house-elm.jpg'
import houseOak from '../../../images/landing/house-oak.jpg'
import houseMaple from '../../../images/landing/house-maple.jpg'

const photo = asset => (asset && asset.default) || asset

export const TOTAL = 18150
export const BEATS = [
  {label: 'Create listing', start: 0, end: 7000},
  {label: 'Share disclosures', start: 7000, end: 12000},
  {label: 'Track buyer activity', start: 12000, end: 15100},
  {label: 'Compare offers', start: 15100, end: 18150},
]
export const CHAPTER_ONE_END = BEATS[0].end - 1

const ADDR = '123 Main St'
const SHARE_TO = [{name: 'Jane Agent', email: 'jane.agent@example.com', ini: 'JA', nb: 1900, eb: 2400, ad: 3200}]
const CREATED = 3200
const NAV = ['Listing feed', 'Disclosure package', 'Offers', 'Documents', 'Messages']
const NAV_FOR_BEAT = [0, 1, 1, 2]
const CRUMB = ['', 'Disclosures', 'Disclosures', 'Offers']

export const DETAILS = [
  {k: 'List price', v: '$1,800,000'},
  {k: 'Property type', v: 'Single family'},
  {k: 'Beds / baths', v: '4 / 4'},
  {k: 'Square feet', v: '3,240'},
  {k: 'Price per sq ft', v: '$556'},
  {k: 'Lot size', v: '6,500 sq ft'},
  {k: 'Year built', v: '1998'},
]

export const FEED = [
  {who: 'Jane Agent', what: 'viewed an offer', when: 'Today, 2:24 pm', dot: '#22c55e'},
  {who: 'Jamie Buyer', what: 'viewed the package', when: 'Today, 2:21 pm', dot: '#46b6ff'},
  {who: 'Sally Agent', what: 'submitted an offer', when: 'Today, 1:47 pm', dot: '#22c55e'},
  {who: 'Kim Buyer', what: 'downloaded 1. [TDS] Transfer disclosure statement', when: 'Today, 12:05 pm', dot: '#46b6ff'},
  {who: 'Alex Agent', what: 'uploaded pre-qual-letter.pdf in offer', when: 'Today, 11:30 am', dot: '#22c55e'},
  {who: 'Alex Agent', what: 'shared the disclosure package with 6 buyer parties', when: 'Today, 9:02 am', dot: '#46b6ff'},
]

export const DOCS = [
  {
    name: 'Coversheet',
    meta: '5 pages | 255.89 KB',
    thumb: photo(houseMain),
  },
  {name: '1. [TDS] Transfer disclosure statement', meta: '3 pages | 412.44 KB', doc: true},
  {name: '2. [SPQ] Seller property questionnaire', meta: '4 pages | 502.10 KB', doc: true},
  {name: '3. Agent visual inspection disclosure AVID', meta: '3 pages | 370.59 KB', doc: true},
  {name: '4. Preliminary title report', meta: '18 pages | 2.14 MB', doc: true},
  {name: '5. HOA documents', meta: '62 pages | 8.77 MB', doc: true},
]

export const VIEWERS = [
  {initials: 'PA', name: 'Pat Agent', role: "Buyer's agent · Example Realty", score: '88 · Hot', chipBg: '#fee2e2', chipFg: '#b91c1c', likely: '82% offer likely', docs: '37 of 37', visits: '9', seen: 'Today'},
  {initials: 'JB', name: 'Jamie Buyer', role: 'Buyer · Unrepresented', score: '76 · Hot', chipBg: '#fee2e2', chipFg: '#b91c1c', likely: '71% offer likely', docs: '37 of 37', visits: '6', seen: 'Yesterday'},
  {initials: 'SA', name: 'Sally Agent', role: "Buyer's agent · Demo Brokerage", score: '63 · Warm', chipBg: '#ffedd5', chipFg: '#c2410c', likely: '55% offer likely', docs: '31 of 37', visits: '4', seen: '3 days ago'},
  {initials: 'KB', name: 'Kim Buyer', role: 'Buyer · Unrepresented', score: '58 · Warm', chipBg: '#ffedd5', chipFg: '#c2410c', likely: '48% offer likely', docs: '28 of 37', visits: '4', seen: '3 days ago'},
  {initials: 'MA', name: 'Mark Agent', role: "Buyer's agent · Sample Homes", score: '52 · Warm', chipBg: '#ffedd5', chipFg: '#c2410c', likely: '41% offer likely', docs: '24 of 37', visits: '3', seen: '4 days ago'},
  {initials: 'LA', name: 'Lee Agent', role: "Buyer's agent · Demo Brokerage", score: '44 · Interested', chipBg: '#fef3c7', chipFg: '#92400e', likely: '33% offer likely', docs: '19 of 37', visits: '2', seen: '4 days ago'},
  {initials: 'RB', name: 'Robin Buyer', role: 'Buyer · Unrepresented', score: '39 · Interested', chipBg: '#fef3c7', chipFg: '#92400e', likely: '27% offer likely', docs: '15 of 37', visits: '2', seen: '5 days ago'},
  {initials: 'TA', name: 'Taylor Agent', role: "Buyer's agent · Sample Homes", score: '33 · Interested', chipBg: '#fef3c7', chipFg: '#92400e', likely: '21% offer likely', docs: '11 of 37', visits: '2', seen: '6 days ago'},
  {initials: 'CA', name: 'Casey Agent', role: "Buyer's agent · Demo Brokerage", score: '24 · Cool', chipBg: '#e8f5ff', chipFg: '#0f6da8', likely: '12% offer likely', docs: '6 of 37', visits: '1', seen: '1 week ago'},
  {initials: 'JB', name: 'Jordan Buyer', role: 'Buyer · Unrepresented', score: '18 · Cool', chipBg: '#e8f5ff', chipFg: '#0f6da8', likely: '8% offer likely', docs: '3 of 37', visits: '1', seen: '1 week ago'},
]

export const OFFERS = [
  {
    initials: 'JA',
    agent: 'Jane Agent',
    email: 'jane.agent@example.com',
    phone: '(555) 010-0101',
    license: '00000001',
    status: 'Opened',
    price: '$1,825,000',
    net: '$1,702,000',
    sub: 'Today, 9:12 am',
    exp: 'Tomorrow, 5:00 pm',
    fin: [
      {k: 'Finance type', v: 'Loan'},
      {k: 'Loan amount', v: '$1,460,000'},
      {k: 'Percent down', v: '20%'},
      {k: 'Down payment', v: '$365,000'},
    ],
    cont: [
      {k: 'Finance contingency', v: '7 days'},
      {k: 'Appraisal contingency', v: '7 days'},
      {k: 'Inspection contingency', v: '5 days'},
      {k: 'Home sale contingency', v: 'Waived'},
    ],
    time: [{k: 'Close of escrow', v: '30 days'}],
    terms: 'Seller to credit buyer 1% of purchase price in lieu of repairs.',
  },
  {
    initials: 'JA',
    agent: 'John Agent',
    email: 'john.agent@example.com',
    phone: '(555) 010-0102',
    license: '00000002',
    status: 'Opened',
    price: '$1,750,000',
    net: '$1,603,000',
    sub: 'Today, 8:40 am',
    exp: 'Tomorrow, 7:00 pm',
    fin: [
      {k: 'Finance type', v: 'Loan'},
      {k: 'Loan amount', v: '$1,400,000'},
      {k: 'Percent down', v: '20%'},
      {k: 'Down payment', v: '$350,000'},
    ],
    cont: [
      {k: 'Finance contingency', v: 'Waived'},
      {k: 'Appraisal contingency', v: '10 days'},
      {k: 'Inspection contingency', v: 'Waived'},
      {k: 'Home sale contingency', v: 'Waived'},
    ],
    time: [{k: 'Close of escrow', v: '21 days'}],
    terms: 'Buyer to cover buyer’s agent fee.',
  },
  {
    initials: 'SA',
    agent: 'Sally Agent',
    email: 'sally.agent@example.com',
    phone: '(555) 010-0103',
    license: '00000003',
    status: 'Opened',
    price: '$1,650,000',
    net: '$1,461,000',
    sub: 'Yesterday, 4:15 pm',
    exp: 'Friday, 5:00 pm',
    fin: [
      {k: 'Finance type', v: 'Cash'},
      {k: 'Loan amount', v: '—'},
      {k: 'Percent down', v: '100%'},
      {k: 'Down payment', v: '$1,650,000'},
    ],
    cont: [
      {k: 'Finance contingency', v: 'Waived'},
      {k: 'Appraisal contingency', v: 'Waived'},
      {k: 'Inspection contingency', v: 'Waived'},
      {k: 'Home sale contingency', v: 'Waived'},
    ],
    time: [{k: 'Close of escrow', v: '14 days'}],
    terms: '—',
  },
]

export const PHOTOS = {
  main: photo(houseMain),
  elm: photo(houseElm),
  oak: photo(houseOak),
  maple: photo(houseMaple),
}

function clamp(v) {
  return Math.max(0, Math.min(1, v))
}

function fade(on, dy = 8) {
  return {op: on ? 1 : 0, ty: on ? 0 : dy}
}

function tabStyle(on) {
  return {
    fg: on ? '#0f6da8' : '#64748b',
    bg: on ? '#e8f5ff' : 'transparent',
    sh: on ? 'inset 0 -2px 0 #46b6ff' : 'none',
  }
}

export function deriveDemoState(t) {
  let cur = BEATS.findIndex(b => t >= b.start && t < b.end)
  if (cur < 0) cur = 0
  const lt = t - BEATS[cur].start
  const done = (beat, x) => cur > beat || (cur === beat && lt >= x)

  const n = Math.max(0, Math.min(ADDR.length, Math.floor((t - 700) / 75)))
  const created = t >= CREATED
  const modalOn = t < 3000
  const panel = on => fade(created && on, 10)
  const navActive = created ? NAV_FOR_BEAT[cur] : -1

  const shared = done(1, 3900)
  const pressing = cur === 1 && lt >= 1450 && lt < 1700
  const toastOn = cur === 1 && lt >= 3900 && lt < 4700
  const smOn = cur === 1 && lt >= 1700 && lt < 3900
  const act = SHARE_TO.find(a => lt >= a.nb && lt < a.ad)
  const typ = (s, st, dur) => s.slice(0, Math.max(0, Math.min(s.length, Math.floor(((lt - st) / dur) * s.length))))
  const smName = act ? typ(act.name, act.nb, 450) : ''
  const smEmail = act && lt >= act.eb ? typ(act.email, act.eb, 650) : ''
  const smCount = SHARE_TO.filter(a => cur === 1 && lt >= a.ad).length
  const onViewers = cur === 2
  const tD = tabStyle(!onViewers)
  const tV = tabStyle(onViewers)
  const tOff = tabStyle(false)

  let p = cur > 2 ? 1 : cur < 2 ? 0 : clamp((lt - 300) / 2000)
  p = 1 - Math.pow(1 - p, 3)
  const nets = done(3, 1500)

  let q = cur > 0 ? 1 : clamp((t - CREATED - 500) / 1800)
  q = 1 - Math.pow(1 - q, 3)
  const r = v => String(Math.round(v * q))

  const nav = NAV.map((_, i) => ({
    bg: i === navActive ? '#e8f5ff' : 'transparent',
    fg: i === navActive ? '#0f6da8' : '#273653',
  }))

  return {
    cur,
    lt,
    modalOp: modalOn ? 1 : 0,
    modalTy: modalOn ? 0 : 12,
    typed: ADDR.slice(0, n),
    caretOp: n < ADDR.length || Math.floor(t / 450) % 2 === 0 ? 1 : 0,
    placeholderOp: n === 0 ? 1 : 0,
    resultsOp: t >= 2000 ? 1 : 0,
    resultsTy: t >= 2000 ? 0 : -4,
    resultBg: t >= 2600 ? '#e8f5ff' : '#ffffff',
    dashOp: created ? 0 : 1,
    listingOp: created ? 1 : 0,
    subNavH: created ? 260 : 0,
    listingTy: created ? 0 : 10,
    navDashBg: created ? 'transparent' : '#e8f5ff',
    navDashFg: created ? '#273653' : '#0f6da8',
    nav,
    badgeOp: created ? 1 : 0,
    crumb: CRUMB[cur],
    crumbOp: created && cur > 0 ? 1 : 0,
    overview: panel(cur === 0),
    feedRows: FEED.map((e, i) => ({...e, ...fade(cur > 0 || t >= CREATED + 1100 + i * 280)})),
    counts: {
      pending: r(1),
      parties: r(6),
      engaged: r(3),
      offers: r(3),
      unread: r(1),
      net: '$' + Math.round(1702000 * q).toLocaleString('en-US'),
    },
    detailRows: DETAILS.map((d, i) => ({...d, ...fade(cur > 0 || t >= CREATED + 300 + i * 180, 6)})),
    disclosures: panel(cur === 1 || cur === 2),
    discStatus: shared ? 'Status: shared · 1 buyer agent · just now' : 'Status: not shared',
    shareBg: pressing ? '#1192e5' : '#46b6ff',
    shareTy: pressing ? 1 : 0,
    tabs: {
      docs: tD,
      ai: tOff,
      viewers: tV,
      activity: tOff,
      viewersPillBg: onViewers ? '#d0ecff' : '#e2e8f0',
      viewersPillFg: onViewers ? '#0f6da8' : '#64748b',
    },
    docsOp: onViewers ? 0 : 1,
    viewersOp: onViewers ? 1 : 0,
    docRows: DOCS.map((d, i) => ({...d, ...fade(done(1, 200 + i * 200))})),
    viewerCount: String(Math.round(34 * p)),
    tiles: {
      hot: String(Math.round(2 * p)),
      warm: String(Math.round(5 * p)),
      interested: String(Math.round(9 * p)),
      cool: String(Math.round(18 * p)),
    },
    viewerRows: VIEWERS.map((v, i) => ({...v, ...fade(done(2, 800 + i * 160))})),
    toastOp: toastOn ? 1 : 0,
    toastTy: toastOn ? 0 : 12,
    share: {
      op: smOn ? 1 : 0,
      ty: smOn ? 0 : 14,
      name: smName,
      email: smEmail,
      namePh: smName ? 0 : 1,
      emailPh: smEmail ? 0 : 1,
      nameCaret: act && lt < act.eb && Math.floor(t / 400) % 2 === 0 ? 1 : 0,
      emailCaret: act && lt >= act.eb && Math.floor(t / 400) % 2 === 0 ? 1 : 0,
      nameBd: act && lt < act.eb ? '#46b6ff' : '#e5e5e5',
      emailBd: act && lt >= act.eb ? '#46b6ff' : '#e5e5e5',
      listOp: smCount ? 1 : 0,
      btnBg: !smCount ? '#a3d8ff' : lt >= 3600 && lt < 3900 ? '#1192e5' : '#46b6ff',
      btnTy: lt >= 3600 && lt < 3900 ? 1 : 0,
      count: smCount === 1 ? '1 recipient' : smCount + ' recipients',
    },
    shareRows: SHARE_TO.map(a => ({...a, ...fade(cur === 1 && lt >= a.ad, 6)})),
    offersOn: panel(cur === 3),
    nsBg: cur === 3 && lt >= 1200 && lt < 1500 ? '#ede9fe' : '#ffffff',
    offerCols: OFFERS.map((o, i) => ({
      ...o,
      ...fade(done(3, 300 + i * 300), 12),
      netOp: nets ? 1 : 0,
    })),
  }
}
